/**
 * The one place this app leaves the SPA and hands the URL back to the browser.
 *
 * ── WHY IT IS A MODULE AND NOT AN INLINE `window.location.replace` ─────────
 * Two reasons, both practical:
 *
 * 1. It is a SEAM. `window.location` is non-configurable in modern jsdom, so a
 *    component that calls it inline cannot be tested without navigating the test
 *    environment. One exported function is a thing `vi.spyOn` can hold.
 * 2. It is a DECLARATION. A full-page navigation out of a single-page app is
 *    unusual enough that it should be greppable — this module has exactly one
 *    caller (the E-SF16 offer hand-off) and any second one deserves the same
 *    scrutiny.
 *
 * ⚠️ `replace`, NEVER `assign`. The offer hand-off must not become a back-button
 * destination: re-entering `/bff/offer/:token` mints a SECOND fresh funnel
 * session, discarding whatever the customer had done since, and spends another of
 * their hourly offer-entry allowances.
 */
export function replaceLocation(url: string): void {
  window.location.replace(url);
}
